import { render } from "./SearchResult.vue?vue&type=template&id=187ae5d7"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dominikheun/Coding/kraiburg-website-typo3/extensions/products/Resources/Private/Vue/product-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__